// @flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import styled from 'styled-components'
import { User } from '../../types'
import colors from '../../styles/colors'
import media from '../../styles/media'
import { fetchUser } from '../../actions/admin'
import Avatar from '../../components/Avatar'

const Header = styled.header`
  background: #ebf0f5;
  padding: 1.5rem 0;
  border-bottom: 1px solid #e1e6eb;
`

const Nav = styled.nav`
  background: #fff;
  border-bottom: 1px solid #e1e6eb;
  margin-bottom: 2rem;
`

const TabContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100px;

  ${media.mdUp} {
    height: 50px;
  }
`

const Tab = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0 1rem;

  &:hover, &:focus {
    text-decoration: none;
  }

  &.active {
    color: ${colors.primary}
    box-shadow: inset 0 -2px ${colors.primary};
  }
`

type Props = {
  user: User,
  children: any,
  fetchUser: Function,
  params: { userId: number }
}

class AdminUser extends Component {
  componentDidMount() {
    this.props.fetchUser(this.props.params.userId)
  }

  props: Props

  render() {
    const { user, children } = this.props

    return (
      <div>
        <Helmet title="Admin" />
        <Header>
          <div className="container">
            <Link
              to="/admin"
              style={{ marginBottom: '1rem', display: 'block' }}
            >
              ← Back
            </Link>
            <div style={{ display: 'flex' }}>
              <Avatar
                email={user.email}
                size={50}
                style={{ borderRadius: '4px', marginRight: '1rem' }}
              />
              <div>
                <h5>{user.name}</h5>
                <div>{user.email}</div>
              </div>
            </div>
          </div>
        </Header>
        <Nav>
          <div className="container">
            <TabContainer>
              <Tab to={`/admin/u/${user.id}/offers`} activeClassName="active">
                <span className="fa fa-file" style={{ marginRight: '6px' }} />
                <span>Offers</span>
              </Tab>
              <Tab
                to={`/admin/u/${user.id}/scheduled-tours`}
                activeClassName="active"
              >
                <span
                  className="fa fa-calendar"
                  style={{ marginRight: '6px' }}
                />
                <span>Tours</span>
              </Tab>
              <Tab to={`/admin/u/${user.id}/alerts`} activeClassName="active">
                <span className="fa fa-bell" style={{ marginRight: '6px' }} />
                <span>Alerts</span>
              </Tab>
              <Tab
                to={`/admin/u/${user.id}/favorites`}
                activeClassName="active"
              >
                <span className="fa fa-heart" style={{ marginRight: '6px' }} />
                <span>Favorites</span>
              </Tab>
            </TabContainer>
          </div>
        </Nav>
        <div className="container">
          <div style={{ margin: '3rem 0' }}>{children}</div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.admin.user
  }),
  {
    fetchUser
  }
)(AdminUser)



// WEBPACK FOOTER //
// ./src/containers/AdminUser/index.js